import {BrowserRouter as Router, useRoutes} from 'react-router-dom';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {Suspense} from 'react';
import ErrorBoundary from './components/ErrorBoundary';
import {CssBaseline, ThemeProvider, GlobalStyles} from '@mui/material';
import theme from './theme';
import routesConfig from './routesConfig';
import {PlaybackProvider} from 'contexts/WatchContext';
import { ActorProvider } from 'contexts/ActorContext';


function App(): JSX.Element {
  // Create a React Query client and disable refetch on window focus
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        // prevent refetch on window focus
        refetchOnWindowFocus: false,
        // enable suspense and error boundary for queries
        suspense: true,
        useErrorBoundary: true,
      },
    },
  });
  return (
    <ThemeProvider theme={theme}>
      {/* Normalize and reset CSS via MUI */}
      <CssBaseline />
      {/* Always show vertical scrollbar to prevent layout shifts */}
      <GlobalStyles styles={{ html: { overflowY: 'scroll' } }} />
      <QueryClientProvider client={queryClient}>
        <Router>
        <PlaybackProvider>
          <ActorProvider>
            <ErrorBoundary>
              <Suspense fallback={null}>
                <AppRoutes />
              </Suspense>
            </ErrorBoundary>
          </ActorProvider>
        </PlaybackProvider>
        </Router>
      </QueryClientProvider>
    </ThemeProvider>
  );
}

/**
 * Renders routes based on configuration via useRoutes().
 * Must be called within a Router context.
 */
const AppRoutes = (): JSX.Element | null => {
  return useRoutes(routesConfig) as JSX.Element;
};

export default App;
